import AppPageTitle from '@/components/AppPageTitle';
import AppTable from '@/components/AppTable';
import AppTableQuery from '@/components/AppTableQuery';
import PATH from '@/config/paths/PATH';
import usePaginatedQuery from '@/hooks/usePaginatedQuery';
import useWheel from '@/redux/hooks/useWheel';
import { getWheelList } from '@/services/wheel.service';
import { formatDate, columnSorter } from '@/utils/formatters';
import { getActiveBadge } from '@/utils/getActiveBadge';
import { Space } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const columns = [
  {
    title: 'No.',
    dataIndex: 'id',
    key: 'id',
    sorter: columnSorter('id'),
    render: (value) => (value ? value : '-'),
  },
  {
    title: 'Tile Name',
    dataIndex: 'name',
    key: 'name',
    sorter: columnSorter('name'),
    render: (value) => (value ? value : '-'),
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    render: (value) => (value ? value : '-'),
  },
  {
    title: 'Showing',
    dataIndex: 'showing',
    key: 'showing',
    render: (data) =>
      getActiveBadge(+data, {
        activeText: 'Yes',
        inactiveText: 'No',
      }),
    sorter: columnSorter('showing'),
  },
  {
    title: 'Date Created',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date) => (date ? formatDate(date) : '-'),
    sorter: columnSorter('created_at', 'date'),
  },
];

const filterOptions = [
  {
    value: null,
    label: 'All',
  },
  {
    value: 1,
    label: 'Yes',
  },
  {
    value: 2,
    label: 'No',
  },
];

function Wheel() {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(null);
  const [queryValues, setQueryValues] = useState({});
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const offset = (pageIndex - 1) * pageSize + 1;
  const { setWheel } = useWheel();

  const {
    data: wheelData,
    isLoading,
    refetch,
    isRefetching,
  } = usePaginatedQuery(
    () =>
      getWheelList({
        ...queryValues,
        limit: pageSize,
        offset: offset,
      }),
    ['wheel', queryValues, pageSize, offset]
  );

  // const handleOnCreate = () => {
  //   navigate(PATH.WHEEL.CREATE);
  // };

  const handleOnEdit = (record) => {
    setWheel(record);
    navigate(PATH.WHEEL.UPDATE.replace(':id', record.id));
  };

  const handleQuery = () => {
    setQueryValues({
      name: searchValue,
      showing: selectedFilter,
    });
    setPageIndex(1);
  };

  const handleReset = () => {
    setSearchValue(null);
    setSelectedFilter(null);
    setQueryValues({});
    setPageIndex(1);
  };

  const handleOnRefresh = () => {
    handleReset();
    refetch();
  };

  return (
    <Space direction="vertical" className="w-full">
      <AppPageTitle title="Manage Wheel" />
      <AppTableQuery
        filterLabel="Showing"
        filterOptions={filterOptions}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        searchPlaceholder="Search tile name"
        handleQuery={handleQuery}
        handleReset={handleReset}
      />
      <AppTable
        columns={columns}
        dataSource={wheelData?.data}
        totalItems={wheelData?.total}
        hasRowAction
        // onCreate={handleOnCreate}
        onEditAction={handleOnEdit}
        onRefresh={handleOnRefresh}
        loading={isLoading || isRefetching}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPageChange={(page, size) => {
          setPageIndex(page);
        }}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
        }}
      />
    </Space>
  );
}

export default Wheel;
